<div>
  <button (click)="oneWaySwitch($event)">
    <svg width="13" height="12" viewBox="0 0 13 12">
      <defs>
        <path
          id="liveSwitcherMask"
          d="M7 0L5.586 1.415l3.242 3.242H0v2h8.828L5.586 9.9 7 11.314l5.657-5.656v-.001l-1.415-1.414z"
        />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <mask id="liveSwitcherMaskB" fill="#fff">
          <use xlink:href="#liveSwitcherMask" />
        </mask>
        <g fill="#EF5350" mask="url(#liveSwitcherMaskB)">
          <path d="M-5-6h21v21H-5z" />
        </g>
      </g>
    </svg>
  </button>
  <button (click)="videoSwitch($event)" class="tow-ways">
    <svg width="16" height="23" viewBox="0 0 16 23">
      <defs>
        <path
          id="liveSwitcherMaskA"
          d="M7 0L5.586 1.415l3.242 3.242H0v2h8.828L5.586 9.9 7 11.314l5.657-5.656v-.001l-1.415-1.414z"
        />
        <path
          id="liveSwitcherMaskC"
          d="M7 0L5.586 1.415l3.242 3.242H0v2h8.828L5.586 9.9 7 11.314l5.657-5.656v-.001l-1.415-1.414z"
        />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(3)">
          <mask id="liveSwitcherMaskB" fill="#fff">
            <use xlink:href="#liveSwitcherMaskA" />
          </mask>
          <g fill="#EF5350" mask="url(#liveSwitcherMaskB)">
            <path d="M-5-6h21v21H-5z" />
          </g>
        </g>
        <g transform="matrix(-1 0 0 1 13 11)">
          <mask id="liveSwitcherMaskD" fill="#fff">
            <use xlink:href="#liveSwitcherMaskC" />
          </mask>
          <g fill="#61B965" mask="url(#liveSwitcherMaskD)">
            <path d="M-5-6h21v21H-5z" />
          </g>
        </g>
      </g>
    </svg>
  </button>
</div>

<button class="small-button" (click)="openSwitcherOption($event)">
  <svg width="10px" height="8px" viewBox="1 -1 8 8">
    <path
      fill-rule="evenodd"
      d="M1.047,0.499 L-0.003,1.547 L4.999,6.539 L10.001,1.547 L8.950,0.499 L4.999,4.442 L1.047,0.499 Z"
    />
  </svg>
</button>
